export type RuntimeConfig = {
  sentryDsn?: string
  sentryEnvironment?: string
  sentryRelease?: string
}

declare global {
  interface Window {
    __KU_AAO_RUNTIME_CONFIG__?: RuntimeConfig
  }
}

export function getRuntimeConfig(): RuntimeConfig {
  return window.__KU_AAO_RUNTIME_CONFIG__ ?? {}
}
